import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Roadmap = () => {
  const phases = [
    {
      quarter: '2025 Q4',
      phase: 'Beta Launch',
      status: 'active',
      date: 'Diciembre 2025',
      color: 'bg-green-500',
      items: [
        { title: 'Lanzamiento plataforma beta', done: false },
        { title: '5-7 modelos de IA disponibles (GPT-4, Claude, Gemini, DALL-E)', done: false },
        { title: 'Servicios básicos operativos', done: false },
        { title: 'Sistema de créditos y planes', done: true },
        { title: 'Generación de texto e imágenes', done: true },
        { title: 'Contabilidad, Legal y Ciberseguridad básicos', done: true }
      ]
    },
    {
      quarter: '2026 Q1-Q2',
      phase: 'Beta Expansion',
      status: 'planned',
      date: 'Enero - Junio 2026',
      color: 'bg-blue-500',
      items: [
        { title: 'Mejoras basadas en feedback de usuarios', done: false },
        { title: 'Optimización de modelos de IA', done: false },
        { title: 'Nuevas integraciones (PayPal, Mercado Pago)', done: false },
        { title: 'Programa de referidos mejorado', done: false },
        { title: 'Panel de administración avanzado', done: false },
        { title: 'Sistema de notificaciones', done: false }
      ]
    },
    {
      quarter: '2026 Q3-Q4',
      phase: 'Formalización',
      status: 'planned',
      date: 'Julio - Diciembre 2026',
      color: 'bg-yellow-500',
      items: [
        { title: 'Constitución como SpA en Chile', done: false },
        { title: 'Preparación servicios enterprise', done: false },
        { title: 'Testing servicios avanzados', done: false },
        { title: 'Expansión de equipo', done: false },
        { title: 'Certificaciones de seguridad', done: false },
        { title: 'Documentación legal completa', done: false }
      ]
    },
    {
      quarter: '2027 Q1',
      phase: 'Enterprise Launch',
      status: 'planned',
      date: 'Enero - Marzo 2027',
      color: 'bg-purple-500',
      items: [
        { title: 'Lanzamiento Contabilidad Empresarial', done: false },
        { title: 'Lanzamiento Legal Empresarial', done: false },
        { title: 'Lanzamiento Ciberseguridad Avanzada', done: false },
        { title: 'Análisis de redes y sistemas', done: false },
        { title: 'Integración con SII Chile', done: false }
      ]
    },
    {
      quarter: '2027 Q2-Q3',
      phase: 'Enterprise Expansion',
      status: 'planned',
      date: 'Abril - Septiembre 2027',
      color: 'bg-red-500',
      items: [
        { title: 'Automatización PyMEs completa', done: false },
        { title: 'Marketing Automation Suite', done: false },
        { title: 'Desarrollo de Software a Medida', done: false },
        { title: 'Páginas Web Profesionales', done: false },
        { title: 'Clientes corporativos', done: false },
        { title: 'Expansión Latinoamérica', done: false }
      ]
    }
  ];

  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-black text-gray-900 dark:text-white mb-4">
              Roadmap GPT-JDP
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Conoce nuestro plan de desarrollo y las próximas funcionalidades que llegarán a la plataforma
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            {phases.map((phase, index) => (
              <div key={phase.quarter} className="mb-8">
                <div className="flex items-start gap-4">
                  <div className="flex flex-col items-center">
                    <div className={`${phase.color} rounded-full w-12 h-12 flex items-center justify-center text-white font-bold shadow-lg`}>
                      {index + 1}
                    </div>
                    {index < phases.length - 1 && (
                      <div className="w-1 h-full bg-gray-200 dark:bg-[#283039] mt-2" style={{minHeight: '100px'}}></div>
                    )}
                  </div>
                  
                  <div className="flex-1 pb-8">
                    <div className="bg-white dark:bg-[#1a2530] rounded-xl p-6 shadow-sm border border-gray-200 dark:border-[#283039]">
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                            {phase.phase}
                          </h3>
                          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                            {phase.quarter} · {phase.date}
                          </p>
                        </div>
                        <div>
                          {phase.status === 'active' ? (
                            <span className="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 px-3 py-1 rounded-full text-sm font-semibold">
                              En Desarrollo
                            </span>
                          ) : (
                            <span className="bg-gray-100 dark:bg-[#283039] text-gray-600 dark:text-gray-400 px-3 py-1 rounded-full text-sm font-semibold">
                              Planificado
                            </span>
                          )}
                        </div>
                      </div>
                      
                      <ul className="space-y-3">
                        {phase.items.map((item, idx) => (
                          <li key={idx} className="flex items-start gap-3">
                            {item.done ? (
                              <span className="material-symbols-outlined text-green-500 text-xl mt-0.5">
                                check_circle
                              </span>
                            ) : (
                              <span className="material-symbols-outlined text-gray-300 dark:text-gray-600 text-xl mt-0.5">
                                radio_button_unchecked
                              </span>
                            )}
                            <span className={`text-sm ${item.done ? 'text-gray-500 dark:text-gray-400 line-through' : 'text-gray-700 dark:text-gray-300'}`}>
                              {item.title}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-8 max-w-3xl mx-auto">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                🚀 Únete a la Fase Beta
              </h3>
              <p className="text-gray-700 dark:text-gray-300 mb-6">
                Sé parte de los primeros usuarios en probar GPT-JDP. Obtén acceso anticipado, 
                descuentos exclusivos de por vida y ayúdanos a construir el futuro de la plataforma.
              </p>
              <a
                href="/register"
                className="inline-block px-8 py-3 bg-primary text-white rounded-lg font-bold hover:bg-primary/90 transition-colors"
              >
                Registrarse Ahora
              </a>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Las fechas son aproximadas y pueden cambiar según el desarrollo y feedback de usuarios.
            </p>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default Roadmap;
